import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
    ApiModel,
    BulkUploadDraftSellerModel,
    BulkUploadDraftSellerModelConverter,
    ListingSellerDraftModel,
    Timestamp,
} from '@steelbuy/ts-shared';
import { DRAFT_BULK_UPLOAD_KEY } from './createBulkUpload';
import axios from '../../axios';

export type UpdateDraftBulkUploadRequest = Pick<BulkUploadDraftSellerModel, 'bulkId' | 'bulkDraftReferenceId'> & {
    bulkListingDraftsUpdates?: ListingSellerDraftModel[];
    deletedListingDrafts?: BulkUploadDraftSellerModel['bulkId'][];
    autoRenew?: boolean;
    expireDate?: Timestamp['value'];
    isSubmission?: boolean;
};

export type SubmitListingResponse = {
    listings: BulkUploadDraftSellerModel[];
    newListingsUnderReview: number;
    updatedListings: number;
    withdrawnListings: number;
};

const submitBulkUpload = async (request: UpdateDraftBulkUploadRequest) => {
    const { data } = await axios.put<SubmitListingResponse>(`/api/seller/bulk-listing-drafts/submission`, request);
    return data;
};

const updateDraftBulkUpload = async (request: UpdateDraftBulkUploadRequest) => {
    const { data } = await axios.put<BulkUploadDraftSellerModel>(`/api/universal/bulk-listing-drafts/update`, request);
    const modelConverter = new BulkUploadDraftSellerModelConverter();
    const convertedData = modelConverter.toViewModel(data as unknown as ApiModel<BulkUploadDraftSellerModel>);
    return convertedData;
};

const mutationFn = ({
    isSubmission,
    ...request
}: UpdateDraftBulkUploadRequest): Promise<BulkUploadDraftSellerModel | SubmitListingResponse> =>
    isSubmission ? submitBulkUpload(request) : updateDraftBulkUpload(request);

export const useUpdateBulkUpload = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn,
        onSuccess: (data) => {
            const bulkUploadData = data as BulkUploadDraftSellerModel;
            queryClient.setQueryData([DRAFT_BULK_UPLOAD_KEY, bulkUploadData.bulkId], bulkUploadData);
        },
    });
};
